/**
 * Feature flag constants.
 *
 * These feature flags are managed in WorkOS and used to control access
 * to various features in the application.
 *
 * Values must match the feature flag names configured in WorkOS.
 */
export const FeatureFlag = {
  // Intake workflow feature flags
  INTAKE_ELIGIBILITY_CHECK_SUPPORT: 'intake-eligibility-check-support',
  INTAKE_PRIOR_AUTH_SUPPORT: 'intake-prior-auth-support',
  INTAKE_READY_TO_CALL_SUPPORT: 'intake-ready-to-call-support',
  INTAKE_SCHEDULING_SUPPORT: 'intake-scheduling-support',
  INTAKE_DOC_UPLOAD: 'intake-doc-upload',
  INTAKE_EXISTING_PATIENT_WORKFLOW: 'intake-existing-patient-workflow',
  INTAKE_EXISTING_PATIENT_WORKFLOW_ROGER:
    'intake-existing-patient-workflow-roger',
  INTAKE_SEE_AI_EXPLANATION: 'intake-see-ai-explanation',
  INTAKE_AI_SCHEDULING: 'intake-ai-scheduling',

  // Medical coding feature flags
  MEDICAL_CODING_ONLY_DOCUMENT_BASED: 'only-document-based-coding',
  MEDICAL_CODING_OE_DATE_SEVERITY_UI: 'medical-coding-oe-date-severity-ui',
  ALLOW_RERUN_COMPLETED_CODING: 'allow-rerun-completed-coding',
  MEDICAL_CODING_CONSIDER_THERAPY_EVAL: 'medical-coding-consider-therapy-eval',
  // Reporting feature flags
  ADOPTION_REPORT_BY_BRANCH: 'adoption-report-by-branch',

  // NOA (Notice of Admission) feature flags
  NOA_MANAGER: 'noa-manager',

  // Admin feature flags
  ADMIN_WORKSHEET_GOALS: 'admin-worksheet-goals',

  // Order Manager feature flags
  ORDER_MANAGER: 'order-manager',

  // OASIS Manager feature flags
  OASIS_MANAGER: 'oasis-manager',

  // RBAC feature flags (will be deleted once we have the new RBAC system in place)
  ROGER_RBAC: 'roger-rbac',

  // Form schema versioning — use stored FormSchemaVersion documents from
  // Roger-Docs-API instead of the legacy question_db pipeline.
  VERSIONED_FORM_SCHEMAS: 'versioned-form-schemas',
} as const;

export type FeatureFlagType = (typeof FeatureFlag)[keyof typeof FeatureFlag];
